export const WALLET_ERRORS = {
  USER_REJECTED_REQUEST: 'User rejected the request.'
}
